import { render, staticRenderFns } from "./FilterForm.vue?vue&type=template&id=b85d84c6&"
import script from "./FilterForm.vue?vue&type=script&lang=js&"
export * from "./FilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports